export default "__VITE_ASSET__BwKRbNxF__"